var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainWrapper"},[_c('Hero'),_c('Grid'),_c('Quote'),_c('Banner'),_c('Collaboration'),_c('Story'),_c('Contributions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }